import { Locale } from "./Locale.ts";
import { settingsStrings } from "./areas/settings.ts";
import { navStrings } from "./areas/nav.ts";
import { footerStrings } from "./areas/footer.ts";
import { flashCardsStrings } from "./areas/flashCards.ts";
import { chartsStrings } from "./areas/charts.ts";
import { consentStrings } from "./areas/consent.ts";
import { workbenchStrings } from "./areas/workbench.ts";
import { manipulativesStrings } from "./areas/manipulatives.ts";
import { baseTenStrings } from "./areas/baseTen.ts";
import { fractionBarsStrings } from "./areas/fractionBars.ts";
import { clockStrings } from "./areas/clock.ts";
import { numberLineStrings } from "./areas/numberLine.ts";
import { doubleNumberLineStrings } from "./areas/doubleNumberLine.ts";
import { dailyPuzzleStrings } from "./areas/dailyPuzzle.ts";
import { cardGamesStrings } from "./areas/cardGames.ts";

/**
 * The merged UI-string catalogue (ADR 0051 part 2), assembled from one file
 * per area (`areas/*.ts`) so each area could be reviewed and committed on its
 * own (plan §2.3).
 *
 * The build-error guard lives in each area file, not here: every area's `es`
 * and `fr` are checked with `satisfies Record<AreaStringKey, string>` against
 * that area's own English keys, so a missing translation fails to compile at
 * the area file - long before this merge runs. This file only concatenates
 * already-complete records; if it type-checks, every area already did.
 */
const en = {
    ...settingsStrings.en,
    ...navStrings.en,
    ...footerStrings.en,
    ...flashCardsStrings.en,
    ...chartsStrings.en,
    ...consentStrings.en,
    ...workbenchStrings.en,
    ...manipulativesStrings.en,
    ...baseTenStrings.en,
    ...fractionBarsStrings.en,
    ...clockStrings.en,
    ...numberLineStrings.en,
    ...doubleNumberLineStrings.en,
    ...dailyPuzzleStrings.en,
    ...cardGamesStrings.en,
};

export type StringKey = keyof typeof en;

export const strings: Record<Locale, Record<StringKey, string>> = {
    en,
    es: {
        ...settingsStrings.es,
        ...navStrings.es,
        ...footerStrings.es,
        ...flashCardsStrings.es,
        ...chartsStrings.es,
        ...consentStrings.es,
        ...workbenchStrings.es,
        ...manipulativesStrings.es,
        ...baseTenStrings.es,
        ...fractionBarsStrings.es,
        ...clockStrings.es,
        ...numberLineStrings.es,
        ...doubleNumberLineStrings.es,
        ...dailyPuzzleStrings.es,
        ...cardGamesStrings.es,
    },
    fr: {
        ...settingsStrings.fr,
        ...navStrings.fr,
        ...footerStrings.fr,
        ...flashCardsStrings.fr,
        ...chartsStrings.fr,
        ...consentStrings.fr,
        ...workbenchStrings.fr,
        ...manipulativesStrings.fr,
        ...baseTenStrings.fr,
        ...fractionBarsStrings.fr,
        ...clockStrings.fr,
        ...numberLineStrings.fr,
        ...doubleNumberLineStrings.fr,
        ...dailyPuzzleStrings.fr,
        ...cardGamesStrings.fr,
    },
};
